import React from "react";
import { Modal } from "react-bootstrap";
import { Row, Col } from "antd";

import TextField from "../../Components/Commons/Forms/TextField";
import NumberInputV2 from "../../Components/Commons/Forms/NumberInputV2";
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { validatePrescriptionDetails } from "../../Components/Helpers/Utilities/Validations/Prescription";

const EditPrescriptionModal = ({
  show,
  onClose,
  isClicked,
  editPrescription,
  isError,
  onChange,
  onSubmit,
}) => {
  return (
    <Modal size="lg" show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title className="form-title">Edit Prescription</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row  gutter={[16,0]}>
          <Col md={24} lg={12}>
            <TextField
              required
              id="generic"
              name="generic"
              formLabel={`Generic`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.generic}
              onChange={onChange}
              isError={isError.generic}
              errorMessage="Generic is required"
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              id="brand"
              name="brand"
              formLabel={`Brand`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.brand}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row  gutter={[16,0]}>
          <Col md={24} lg={12}>
            <TextField
              required
              id="preparation"
              name="preparation"
              formLabel={`Preparation`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.preparation}
              onChange={onChange}
              isError={isError.preparation}
              errorMessage="Preparation is required"
            />
          </Col>
          <Col md={24} lg={12}>
            <NumberInputV2
              id="quantity"
              name="quantity"
              formLabel={`Quantity`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.quantity}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row  gutter={[16,0]}>
         <Col md={24} lg={12}>
            <TextField
              id="form"
              name="form"
              formLabel={`Form`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.form}
              onChange={onChange}
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              id="dosage"
              name="dosage"
              formLabel={`Dosage`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.dosage}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row  gutter={[16,0]}>
         <Col md={24} lg={12}>
            <TextField
              id="frequency"
              name="frequency"
              formLabel={`Frequency`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.frequency}
              onChange={onChange}
            />
          </Col>
          <Col md={24} lg={12}>
            <TextField
              id="duration"
              name="duration"
              formLabel={`Duration`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.duration}
              onChange={onChange}
            />
          </Col>
        </Row>
        <Row  gutter={[16,0]}>
         <Col md={24}>
            <TextField
              id="timing"
              name="timing"
              formLabel={`Timing`}
              size={`sm`}
              value={editPrescription?.prescription_details[0]?.timing}
              onChange={onChange}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <BtnDelete 
            label={"Close"} 
            size={"md"} 
            onClick={onClose} 
            isClicked={isClicked} 
        />
        <BtnSave 
            label={"Submit"} 
            size={"md"} 
            onClick={onSubmit} 
            isClicked={isClicked} 
            disabled={
                validatePrescriptionDetails(editPrescription.prescription_details)
            }
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EditPrescriptionModal;
